import React, { Fragment } from 'react';
import { Button } from 'evergreen-ui';
import { isFileUrlImageBase64, getExtensionByBase64, isMimeTypeImage } from './file';

const IsJsonString = (str) => {
	try {
		JSON.parse(str);
	} catch (e) {
		return false;
	}
	return true;
};

const getOpenCheckboxAnswer = (content) => {
	const valuesWithoutOpen = content.values.filter(answer => answer !== 'open');

	const values = valuesWithoutOpen.map(answer => (
		<div>- { answer }</div>
	));

	if (content.openOption !== '') {
		values.push((
			<div>- { content.openOption }</div>
		));
	}

	return values;
};

const getFileAnswer = (name, url, isImage) => (
	<a
		href={url}
		className="d-block mb-2"
		target="_blank"
		rel="noopener noreferrer"
		download={name}
	>
		{
			isImage
				? (
					<img
						src={url}
						alt="Imagem enviada"
						className="d-block w-25 mb-2 img-thumbnail"
					/>
				)
				: (
					<Button
						iconBefore="cloud-download"
						color="info"
						marginRight={16}
						height={48}
					>
						{name}
					</Button>
				)
		}
	</a>
);

export const buildQuestionsAndAnswers = (apiResponseData) => {
	if (apiResponseData.relationships.step.alias === 'dados_cadastrais') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					if (parseInt(answer.relationships.question.data.id, 10) === parseInt(question.id, 10)) {
						if (IsJsonString(answer.attributes.content)) {
							data.answer = JSON.parse(answer.attributes.content);
							data.answer = (
								<div className="ml-3">
									<span>{`Nome: ${data.answer.nome}`}</span> <br />
									<span>{`CNPJ: ${data.answer.cnpj}`}</span> <br />
									<span>{`CEP: ${data.answer.cep}`}</span> <br />
									<span>{`Telefone: ${data.answer.telefone}`}</span> <br />
									<span>{`Endereço: ${data.answer.endereco}`}</span> <br />
									<span>{`Complemento: ${data.answer.complemento}`}</span> <br />
									<span>{`Estado: ${data.answer.estado}`}</span> <br />
									<span>{`Cidade: ${data.answer.cidade}`}</span>
								</div>
							);
							return data;
						}
					}

					return '';
				});

				return data;
			},
		);
	}

	if (apiResponseData.relationships.step.alias === 'plano_contratados') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					if (parseInt(answer.relationships.question.data.id, 10) === parseInt(question.id, 10)) {
						if (IsJsonString(answer.attributes.content)) {
							data.answer = JSON.parse(answer.attributes.content);
							data.answer = (
								<div className="pt-3 pb-3">
									<div className="ml-3">
										<span><b>Plano:</b> {data.answer.plan.replace('_', ' - ')}</span> <br />
										<span><b>Canais:</b></span>
										{ apiResponseData.attributes.product.channels.map(channel => (
											<div>
												{ (channel.channel === 'googleDisplay' && channel.value !== '0%') ? (<Fragment><span>Google Display</span> <br /></Fragment>) : '' }
												{ (channel.channel === 'googleSearch' && channel.value !== '0%') ? (<Fragment><span>Google Search</span> <br /></Fragment>) : '' }
												{ (channel.channel === 'facebook' && channel.value !== '0%') ? (<Fragment><span>Facebook</span> <br /></Fragment>) : '' }
												{ (channel.channel === 'instagram' && channel.value !== '0%') ? (<Fragment><span>Instagram</span> <br /></Fragment>) : '' }
											</div>
											)) }
										<span><b>Valor:</b> {apiResponseData.attributes.sale_net_value}</span><br />
										{ (typeof apiResponseData.attributes.fee_value !== 'undefined') ? (
											<Fragment>
												<span>
													<b>Fee:</b> { `${apiResponseData.attributes.fee_percent * 100}%`}
												</span><br />
												<span>
													<b>Valor do Fee:</b> R${apiResponseData.attributes.fee_value}
												</span><br />
												<span>
													<b>Valor em Mídia:</b> R${apiResponseData.attributes.media_value}
												</span><br />
											</Fragment>
											) : ''
										}
									</div>
									{(typeof apiResponseData.attributes.fee_value !== 'undefined') ? (
										<div className="ml-3">
											{apiResponseData.attributes.budgets.map(channel => (
												<div>
													{(channel.channel === 'googleDisplay' && channel.alloc !== '0,00')
														? (
															<Fragment>
																<hr />
																<span><b>Google Display:</b> {channel.value}</span>
																<br />
																<span>- Valor em Google Display: R${channel.alloc}</span><br />
																<span>
																	- Valor Diário em Google Display:
																	R${channel.daily_alloc}
																</span><br />
															</Fragment>
														)
														: ''
													}
													{(channel.channel === 'googleSearch' && channel.alloc !== '0,00')
														? (
															<Fragment>
																<hr />
																<span><b>Google Search:</b> {channel.value}</span> <br />
																<span>- Valor em Google Search: R${channel.alloc}</span><br />
																<span>
																	- Valor Diário em Google Search:
																	R${channel.daily_alloc}
																</span><br />
															</Fragment>
														)
														: ''
													}
													{(channel.channel === 'facebook' && channel.alloc !== '0,00')
														? (
															<Fragment>
																<hr />
																<span><b>Facebook:</b> {channel.value}</span> <br />
																<span>- Valor em Facebook: R${channel.alloc}</span><br />
																<span>
																	- Valor Diário em Google Facebook:
																	R${channel.daily_alloc}
																</span><br />
															</Fragment>
														)
														: ''
													}
													{(channel.channel === 'instagram' && channel.alloc !== '0,00')
														? (
															<Fragment>
																<hr />
																<span><b>Instagram:</b> {channel.value}</span> <br />
																<span>- Valor em Instagram: R${channel.alloc}</span><br />
																<span>
																	- Valor Diário em Instagram:
																	R${channel.daily_alloc}
																</span><br />
															</Fragment>
														)
														: ''
													}
												</div>
											))}
										</div>
									) : ''
									}
								</div>

							);
						}
					}

					return '';
				});

				return data;
			},
		);
	}

	if (apiResponseData.relationships.step.alias === 'caracteristicas_estoque') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					if (parseInt(answer.relationships.question.data.id, 10) === parseInt(question.id, 10)) {
						if (question.id === '39') {
							const arrayAnswer = JSON.parse(answer.attributes.content);

							data.answer = getOpenCheckboxAnswer(arrayAnswer);

							return data;
						}
					}

					return '';
				});

				return data;
			},
		);
	}

	if (apiResponseData.relationships.step.alias === 'segmentacao_campanha') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					const hasAnswer = answer.attributes.content;
					const questionMatch = answer.relationships.question.data.id === question.id;
					const typeQuestion = question.relationships.question_types.data.attributes.field_type;
					if (hasAnswer && questionMatch) {
						if (question.id === '24') {
							data.answer = answer.attributes.content;
							return data;
						}

						if (question.id === '40') {
							data.answer = answer.attributes.content;
							return data;
						}

						if (question.id === '41' || question.id === '29') {
							const content = JSON.parse(answer.attributes.content);
							data.answer = content.join(', ').replace(/^, /, '');
						}


						if (typeQuestion === 'open-checkbox' || question.id === '28') {
							const content = JSON.parse(answer.attributes.content);
							data.answer = getOpenCheckboxAnswer(content);
						}

						return data;
					}

					return '';
				});

				return data;
			},
		);
	}

	if (apiResponseData.relationships.step.alias === 'peca_grafica') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					const hasAnswer = answer.attributes.content;
					const questionMatch = answer.relationships.question.data.id === question.id;
					const typeQuestion = question.relationships.question_types.data.attributes.field_type;
					if (hasAnswer && questionMatch) {
						if (question.id === '30') {
							data.answer = answer.attributes.content;
							return data;
						}

						if (question.id === '31' || question.id === '32') {
							data.answer = answer.attributes.content.map((file) => {
								if (typeof file === 'string') {
									return getFileAnswer(`File.${getExtensionByBase64(file)}`, file, isFileUrlImageBase64(file));
								}
								return getFileAnswer(file.name, file.url, isMimeTypeImage(file.mime_type));
							});

							return data;
						}

						if (typeQuestion === 'open-checkbox') {
							const content = JSON.parse(answer.attributes.content);
							data.answer = getOpenCheckboxAnswer(content);
						}

						if (question.id === '37') {
							data.answer = answer.attributes.content ? (<span>{ answer.attributes.content }</span>) : 'Vazio';

							return data;
						}

						if (question.id === '36') {
							if (!answer.attributes.content) {
								return data;
							}

							data.answer = JSON.parse(answer.attributes.content);
							data.answer = (<span>{data.answer.values}</span>);

							return data;
						}

						if (question.id === '35') {
							if (!answer.attributes.content) {
								return data;
							}

							data.answer = JSON.parse(answer.attributes.content);

							if (data.answer.openOption !== '') {
								data.answer = (
									<div>- { data.answer.openOption }</div>
								);

								return data;
							}

							data.answer = (
								<div>
									<img src={`/images/carros/${data.answer.values.toLowerCase()}.png`} alt={data.answer.values} className="d-block w-25" />
									<span className="d-inline-block text-center w-25">{data.answer.values}</span> <br />
								</div>
							);

							return data;
						}
					}

					return '';
				});

				return data;
			},
		);
	}

	if (apiResponseData.relationships.step.alias === 'alcance_campanha') {
		return apiResponseData.relationships.step.relationships.questions.map(
			(question) => {
				const data = { title: question.attributes.title };
				apiResponseData.relationships.answers.map((answer) => {
					if (parseInt(answer.relationships.question.data.id, 10) === parseInt(question.id, 10)) {
						if (IsJsonString(answer.attributes.content)) {
							if (question.id === '23') {
								data.answer = JSON.parse(answer.attributes.content);

								let addresses = (<br />);

								data.answer.map((answerData, index) => {
									addresses = (
										<Fragment>
											{addresses}
											<div>
												<span>{`Endereço: ${answerData.nameAddress}`}</span> <br />
												<span>{`Tipo: ${answerData.type}`}</span> <br />
												<span>{`Raio: ${answerData.valueRange} km`}</span> <br />
											</div>
											{data.answer.length > index && data.answer.length > 1 ? <hr /> : ''}
										</Fragment>
									);

									data.answer = addresses;
									return data;
								});

								return data;
							}

							if (question.id === '25') {
								data.answer = JSON.parse(answer.attributes.content);

								data.answer.values.map((call, number) => {
									data.answer = (
										<div>
											<span>{`${number + 1}ª chamada: ${call}`}</span> <br />
										</div>
									);

									return data;
								});

								return data;
							}

							if (question.id === '26') {
								data.answer = JSON.parse(answer.attributes.content);

								data.answer.values.map((call, number) => {
									data.answer = (
										<div>
											<span>{`${number + 1}ª chamada: ${call}`}</span> <br />
										</div>
									);

									return data;
								});

								return data;
							}

							if (question.id === '27') {
								data.answer = JSON.parse(answer.attributes.content);

								data.answer.map((call, number) => {
									data.answer = (
										<div>
											<span>{`${number + 1}ª chamada: ${call}`}</span> <br />
										</div>
									);

									return data;
								});

								return data;
							}

							if (question.id === '28') {
								data.answer = JSON.parse(answer.attributes.content);

								data.answer.values.map((call, number) => {
									data.answer = (
										<div>
											<span>{`${number + 1}ª chamada: ${call}`}</span> <br />
										</div>
									);

									return data;
								});

								return data;
							}

							if (question.id === '29') {
								data.answer = JSON.parse(answer.attributes.content);

								data.answer.map((call, number) => {
									data.answer = (
										<div>
											<span>{`${number + 1}ª chamada: ${call}`}</span> <br />
										</div>
									);

									return data;
								});

								return data;
							}

							data.answer = JSON.parse(answer.attributes.content);
							return data;
						}

						data.answer = answer.attributes.content;
						return data;
					}

					return '';
				});

				return data;
			},
		);
	}

	return apiResponseData.relationships.step.relationships.questions.map((question) => {
		const data = { title: question.attributes.title };
		apiResponseData.relationships.answers.map((answer) => {
			if (parseInt(answer.relationships.question.data.id, 10) === parseInt(question.id, 10)) {
				if (IsJsonString(answer.attributes.content)) {
					data.answer = JSON.parse(answer.attributes.content);
					return data;
				}

				data.answer = answer.attributes.content;
				return data;
			}

			return '';
		});

		return data;
	});
};
